// @flow
import BaseComponent from '../base_component/base_component'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import {isEqual, snakeCase} from "lodash-es";

export default class Carosel extends BaseComponent {
    carosel: JQuery;
    data: Array;

    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);

        this.load(true);
    }

    load(initialLoad=false) {
        let self = this;
        var headers: any = {'Component-Initial-Table-Load': initialLoad.toString()};
        $.ajax({
            dataType: 'json',
            headers: headers,
            url: this.options.controller,
            success: (response) => { self.initCarosel(response); }
        });

    }

    initCarosel(data) {
        let container = $(this.component).find('.carosel-container');
        if (this.options.height) {
            container.css('height', this.options.height);
        }
        if (this.options.centerMode != false && !this.options.hero) {
            container.addClass('centered');
        }
        if (this.options.hero) {
            container.addClass('hero');
        }
        if (!this.options.hero && !this.options.responsive) {
            this.options.responsive = [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }

        let carosel = $(this.component).find('.carosel')
        this.data = data.data;
        if (this.data.length > 0) {
            this.setContent(this.data)
            this.carosel = carosel.slick(this.getOptions(this.options))
        } else {
            this.setContent(
                `<div class='no-content-message'>
                    <span>No data available</span>
                </div>`
            );
        }

        $(this.component).find('.carosel-spinner').hide();
    }

    setContent(content) { $(this.component).find('.carosel').html(content) }

    getOptions(options) {
        let slidesToShow, slidesToScroll, centerMode;
        if (options.hero) {
            slidesToShow = 1;
            slidesToScroll = 1;
            centerMode = false;
        } else {
            slidesToShow = options.slidesToShow ? options.slidesToShow : 3;
            slidesToScroll = options.slidesToScroll ? options.slidesToScroll : 3;
            centerMode = options.centerMode ? options.centerMode : true;
            if (slidesToShow > this.data.length) {
                slidesToShow = this.data.length;
                slidesToScroll = slidesToShow;
                centerMode = false;
            }
        }
        return {
            dots: options.dots ? options.dots : true,
            infinite: true,
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll,
            centerMode: centerMode,
            centerPadding: '60px',
            responsive: options.responsive
        }
    }
}